<nav
  class="sticky z-50 px-8 py-3 grid grid-cols-[1fr_auto_1fr] gap-6 items-center text-white bg-[#132f5a] shadow-md"
>
  <a routerLink="/" class="justify-self-start">
    <img width="160" height="40" priority ngSrc="/logo-horizontal.png" />
  </a>

  <div class="flex justify-self-center bg-white/10 rounded-full p-1 gap-0.5">
    <a
      routerLink="/"
      class="px-4 py-1.5 rounded-full text-sm font-medium text-white/70 hover:text-white hover:bg-white/10 transition-colors"
      routerLinkActive="bg-white! text-[#1a3a6b]! font-semibold!"
      [routerLinkActiveOptions]="{ exact: true }"
      >Domů</a
    >
    <a
      routerLink="/schools"
      class="px-4 py-1.5 rounded-full text-sm font-medium text-white/70 hover:text-white hover:bg-white/10 transition-colors"
      routerLinkActive="bg-white! text-[#1a3a6b]! font-semibold!"
      >Moje školy</a
    >
    <a
      routerLink="/svps"
      class="px-4 py-1.5 rounded-full text-sm font-medium text-white/70 hover:text-white hover:bg-white/10 transition-colors"
      routerLinkActive="bg-white! text-[#1a3a6b]! font-semibold!"
      >ŠVP</a
    >
  </div>

  <div class="flex justify-self-end items-center gap-4">
    <app-school-picker />
    <div class="w-px h-5 bg-white/20"></div>
    <div class="flex items-center gap-2.5">
      <div class="text-right">
        <p class="text-xs text-white/70 leading-tight">{{ authService.currentUser()?.email }}</p>
        <p class="text-[10px] text-white/40 uppercase tracking-wider leading-tight mt-0.5">
          {{ authService.currentUser()?.role ?? null | userRole }}
        </p>
      </div>
      <button
        matIconButton
        [matMenuTriggerFor]="menu"
        class="ring-1 ring-white/25"
        style="
          --mat-icon-button-state-layer-color: white;
          --mat-icon-button-ripple-color: rgba(255, 255, 255, 0.15);
        "
      >
        <mat-icon class="text-white!">account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu" xPosition="before" class="user-menu">
        <div class="flex items-center gap-2.5 px-3 py-2" (click)="$event.stopPropagation()">
          <mat-icon class="text-primary! shrink-0 text-3xl! h-8! w-8!">account_circle</mat-icon>
          <div class="min-w-0">
            <p class="truncate text-sm font-medium text-on-surface leading-tight">
              {{ authService.currentUser()?.email }}
            </p>
            <p class="text-[10px] uppercase tracking-wider text-on-surface-variant leading-tight">
              {{ authService.currentUser()?.role | userRole }}
            </p>
          </div>
        </div>
        <mat-divider />
        @if (authService.isAdmin()) {
          <a mat-menu-item routerLink="/users">
            <mat-icon>group</mat-icon>
            <span>Uživatelé</span>
          </a>
          <a mat-menu-item routerLink="/rvp-versions">
            <mat-icon>description</mat-icon>
            <span>RVP Verze</span>
          </a>
          <mat-divider />
        }
        <button mat-menu-item (click)="openEditProfileDialog()">
          <mat-icon>badge</mat-icon>
          <span>Upravit jméno</span>
        </button>
        <button mat-menu-item (click)="openChangeEmailDialog()">
          <mat-icon>alternate_email</mat-icon>
          <span>Změnit e-mail</span>
        </button>
        <button mat-menu-item (click)="openChangePasswordDialog()">
          <mat-icon>lock_reset</mat-icon>
          <span>Změnit heslo</span>
        </button>
        <a mat-menu-item routerLink="/co-je-noveho">
          <mat-icon>new_releases</mat-icon>
          <span>Co je nového</span>
        </a>
        <a mat-menu-item routerLink="/podminky-uzivani">
          <mat-icon>gavel</mat-icon>
          <span>Podmínky užívání</span>
        </a>
        <button mat-menu-item class="text-error!" (click)="authService.logout()">
          <mat-icon class="text-error!">logout</mat-icon>
          <span>Odhlásit se</span>
        </button>
      </mat-menu>
    </div>
  </div>
</nav>
